import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import axios from 'axios';
import { Alert, Modal } from 'antd';
import { axiosErrorHandler } from "../../../../../swzutils";
import StripeCreditCardForm, {} from '../StripeCreditCardForm';
class AddStoredPaymentMethodModal extends React.Component {
    cardFormRef;
    constructor(props) {
        super(props);
        this.cardFormRef = React.createRef();
        this.state = {
            loading: false,
            errorMessage: null
        };
    }
    doStorePaymentMethod = (stripePaymentMethodId) => {
        let url = '/admin/v1/billing/payment-methods';
        if (this.props.tenantId) {
            url += `?tenantId=${this.props.tenantId}`;
        }
        axios.post(url, {
            paymentMethodId: stripePaymentMethodId
        }).then(response => {
            this.setState({
                loading: false
            });
            this.props.onAdded(response.data);
        }).catch(error => {
            axiosErrorHandler(error, (errorMessage) => {
                this.setState({
                    loading: false,
                    errorMessage: errorMessage
                });
            });
        });
    };
    submit = (e) => {
        e.preventDefault();
        this.setState({ loading: true, errorMessage: null });
        this.cardFormRef?.current?.createStripePaymentMethodId((stripePaymentMethodId) => {
            if (stripePaymentMethodId) {
                this.doStorePaymentMethod(stripePaymentMethodId);
            }
            else {
                // if stripePaymentMethodId is null then creating the payment method failed with an
                // error and the form shows it's own error.
                this.setState({ loading: false, errorMessage: null });
            }
        });
    };
    render() {
        return (_jsxs(Modal, { title: "Add a Stored Credit Card", open: this.props.open, onCancel: this.props.onCancel, onOk: this.submit, confirmLoading: this.state.loading, destroyOnHidden: true, children: [this.props.open &&
                    _jsx(StripeCreditCardForm, { ref: this.cardFormRef }), this.state.errorMessage &&
                    _jsx(Alert, { type: "error", title: this.state.errorMessage, banner: true })] }));
    }
}
export default AddStoredPaymentMethodModal;
